module.exports = __webpack_public_path__ + "static/img/spec-right-bottom.78115c90.png";